export const unmaskPostalCode = (postalCode: string): string => {
  return postalCode.replace('.', '').replace('-', '');
};

export const unmaskPhoneNumber = (phoneNumber: string): string => {
  return phoneNumber
    .replace('(', '')
    .replace(')', '')
    .replace(' ', '')
    .replace(' ', '')
    .replace(' ', '')
    .replace('-', '');
};

export const onlyDigits = (value?: string): string => (value || '').replace(/\D/g, '');

export const maskPhoneNumber = (phoneNumber: string): string => {
  const cleaned = phoneNumber.replace(/\D/g, '').slice(0, 11);
  const match = cleaned?.match(/(\d{0,2})(\d{0,5})(\d{0,4})/);
  if (!match) return '';

  return !match[2] ? match[1] : `(${match[1]}) ${match[2]}${match[3] ? `-${match[3]}` : ''}`;
};

// Exemplo: "11987654321" → "(11) 98765-4321"
